// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__zBe6-","footer":"ModalInfo_footer__3HEvJ"};